/* eslint-disable react/jsx-pascal-case */
import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { checkDoesObjectHaveContent, deepCopy, toNumber, setNull, deleteCookie } from "../components/Common";
import { Palette } from "../AppConfig";
import Drawer from "@material-ui/core/Drawer";
import * as BSL_Common from "../components/BSL_CommonControls";
import BSL_TextInput from "../components/BSL_TextInput";
import { saveUserToWeb } from "../redux_store/appState";
import { checkJobStateValidationSchema } from "../redux_store/jobState";
import BSL_Button from "../components/BSL_Button";
import ManageBusiness from "./ManageBusiness/ManageBusiness";
import Message from "../components/Message";
import SegmentedButtonGroup from "../components/SegmentedButtonGroup";
import Switch from "@material-ui/core/Switch";

const useStyles = makeStyles({
    root: {
        paddingRight: "10px",
        position: "fixed",
        right: "0px",
        top: "0px",
        height: "100%",
        width: "500px",
        borderRadius: "0px",
        textAlign: "left",
        display: "flex",
        backgroundColor: "#edf0f3e8",
        borderLeft: "3px solid #0000001f",
        backdropFilter: "blur(4px)",
        flexDirection: "column",
        overflow: "auto",
    },

    col_header: {
        backgroundColor: Palette.Control.FieldersDarkBlue,
        color: "white",
        fontSize: "12px",
        fontFamily: '"Univers45", "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontWeight: "200",
        textAlign: "center",
        padding: "5px 0px",
    },

    row_header: {
        display: "flex",
    },

    row_style: {
        padding: "0px 4px !important",
    },

    row_cell: {
        textAlign: "center",
        display: "flex",
    },

    admin_drawer_root: {
        top: "0px",
        left: "0px",
        width: "95%",
        height: "-webkit-fill-available",
        display: "flex",
        overflow: "hidden",
        position: "fixed",
        textAlign: "left",
        borderLeft: "3px solid #0000001f",
        borderRadius: "0px",
        flexDirection: "column",
        backdropFilter: "blur(4px)",
        backgroundColor: "#edf0f3e8",
    },
});

export const LogOut = ({ dispatch }) => {
    deleteCookie("CDS_token");
    localStorage.clear();
    dispatch({
        type: "LOG_OUT",
    });
    localStorage.clear();
    setTimeout(function () {
        localStorage.clear();
        window.location.reload();
    }, 1000);
};

export default function ManageUser(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const user = useSelector((state) => state?.app?.user);
    const validationSchema = useSelector((state) => state?.config?.validationSchema);
    const [newUser, setNewUser] = React.useState(null);
    const [errorState, setErrorState] = React.useState(null);
    const [showMessage, setShowMessage] = React.useState(false);
    const [saveButtonDisabled, setSaveButtonDisabled] = React.useState(false);

    React.useEffect(() => {
        setNewUser(user);

        let newErrorState = setNull(user);
        for (let param in user) {
            if (validationSchema?.Customer?.[param]) {
                let error = "";
                error = checkJobStateValidationSchema(validationSchema, "Customer", null, param, user[param]);
                newErrorState[param] = error;
            }
        }
        for (let param in user?.BusinessDetails) {
            if (validationSchema?.Distributor?.[param]) {
                let error = "";
                error = checkJobStateValidationSchema(
                    validationSchema,
                    "Distributor",
                    null,
                    param,
                    user?.BusinessDetails?.[param]
                );
                newErrorState.BusinessDetails[param] = error;
            }
        }
        setErrorState(newErrorState);
    }, [user, props.open]); // eslint-disable-next-line react-hooks/exhaustive-deps

    const saveUser = () => {
        //check no errors
        let errors_has_content = checkDoesObjectHaveContent(errorState);

        if (errors_has_content) {
            setShowMessage({
                type: "error",
                message: "Error: [" + errors_has_content.key + "] " + errors_has_content.value,
            });
            return;
        }

        dispatch(saveUserToWeb(newUser, true, true));
        props.toggleDrawer();
    };

    const setErrorStateBusiness = (businessErrorState) => {
        let newErrorState = deepCopy(errorState);
        newErrorState.BusinessDetails = businessErrorState;
        setErrorState(newErrorState);
    };

    const updateNewUser = (param) => (e) => {
        let val = e;
        if (val?.target?.value !== undefined) val = val?.target?.value;

        let updateUser = deepCopy(newUser);
        updateUser[param] = val;
        setNewUser(updateUser);

        // validate using customer validation schema
        if (validationSchema?.Customer?.[param]) {
            let error = "";
            error = checkJobStateValidationSchema(validationSchema, "Customer", null, param, val);
            let newErrorState = deepCopy(errorState);
            newErrorState[param] = error;
            setErrorState(newErrorState);
        }
    };

    const setCurrentBusiness = (newBusinessDetails) => {
        let updateUser = deepCopy(newUser);
        updateUser.BusinessDetails = deepCopy(newBusinessDetails);
        setNewUser(updateUser);
    };

    if (!user || !newUser) return <></>;

    return (
        <Drawer anchor="right" open={props.open} onClose={props.toggleDrawer}>
            <div className={classes.root}>
                <div style={{ minHeight: "30px" }}></div>

                <BSL_Common.SectionContainer>
                    <BSL_Common.SectionHeader>User Settings</BSL_Common.SectionHeader>
                    {user?.apiKey != null && (
                        <>
                            <BSL_Common.SectionRow style={{ fontSize: "small", margin: "-10px 8px" }}>
                                <p>
                                    API KEY: <b>{user?.apiKey}</b>
                                </p>
                            </BSL_Common.SectionRow>
                        </>
                    )}
                    <BSL_Common.SectionRow>
                        <SegmentedButtonGroup
                            tight
                            label="Preferred Designer State"
                            ButtonGroupStyle={{
                                flexWrap: "wrap",
                            }}
                            style={{ flex: "none" }}
                            value={newUser?.preferences?.designerMode ?? "Plan View"}
                            items={["Plan View", "Split", "Model View"]}
                            onChange={(e, value) =>
                                setNewUser({
                                    ...newUser,
                                    preferences: {
                                        ...newUser.preferences,
                                        designerMode: value,
                                    },
                                })
                            }
                        />
                    </BSL_Common.SectionRow>
                    <BSL_Common.SectionRow>
                        <SegmentedButtonGroup
                            tight
                            label="Preferred BOM Mode"
                            ButtonGroupStyle={{
                                flexWrap: "wrap",
                            }}
                            style={{ flex: "none" }}
                            value={newUser?.preferences?.bomMode ?? "Embedded"}
                            items={["Embedded", "New Window"]}
                            onChange={(e, value) =>
                                setNewUser({
                                    ...newUser,
                                    preferences: {
                                        ...newUser.preferences,
                                        bomMode: value,
                                    },
                                })
                            }
                        />
                    </BSL_Common.SectionRow>
                    <BSL_Common.SectionRow>
                        <BSL_TextInput
                            label="Username"
                            tight
                            disabled
                            value={newUser.id}
                            helperText={"*sync with Salesforce"}
                        />
                    </BSL_Common.SectionRow>
                    <BSL_Common.SectionRow>
                        <BSL_TextInput
                            label="Display Name"
                            preValidate="name"
                            tight
                            disabled
                            value={newUser.DisplayName}
                            onBlur={updateNewUser("DisplayName")}
                            error={errorState?.DisplayName}
                            helperText={"*sync with Salesforce"}
                        />
                        <BSL_TextInput
                            label="First Name"
                            preValidate="name"
                            tight
                            disabled
                            value={newUser.FirstName}
                            onBlur={updateNewUser("FirstName")}
                            error={errorState?.FirstName}
                            helperText={"*sync with Salesforce"}
                        />
                        <BSL_TextInput
                            label="Last Name"
                            preValidate="name"
                            tight
                            disabled
                            value={newUser.LastName}
                            onBlur={updateNewUser("LastName")}
                            error={errorState?.LastName}
                            helperText={"*sync with Salesforce"}
                        />
                    </BSL_Common.SectionRow>
                    <BSL_Common.SectionRow>
                        <BSL_TextInput
                            label="Email"
                            tight
                            disabled
                            value={newUser.Email}
                            onBlur={updateNewUser("Email")}
                            error={errorState?.Email}
                            helperText={"*sync with Salesforce"}
                        />
                        <BSL_TextInput
                            label="Phone"
                            tight
                            disabled
                            value={newUser.Phone}
                            onBlur={updateNewUser("Phone")}
                            error={errorState?.Phone}
                            helperText={"*sync with Salesforce"}
                        />
                    </BSL_Common.SectionRow>
                </BSL_Common.SectionContainer>

                {toNumber(user?.Role) >= 9 && (
                    <ManageBusiness
                        BusinessDetails={newUser.BusinessDetails}
                        UpdateBusiness={setCurrentBusiness}
                        ErrorState={errorState.BusinessDetails}
                        SetErrorState={setErrorStateBusiness}
                        sourcePage={"ManageUser"}
                        setSaveButtonDisabled={setSaveButtonDisabled}
                    />
                )}

                <BSL_Common.SectionRow
                    style={{
                        justifyContent: "center",
                        marginTop: "20px",
                    }}
                >
                    <BSL_Button label="Save Changes" onClick={saveUser} disabled={saveButtonDisabled} />
                    <BSL_Button label="Cancel" style={{ marginLeft: "24px" }} onClick={props.toggleDrawer} secondary />
                </BSL_Common.SectionRow>

                <BSL_Common.SectionContainer
                    style={{
                        justifyContent: "center",
                        marginTop: "20px",
                    }}
                >
                    <BSL_Button
                        onClick={() => LogOut({ dispatch })}
                        secondary
                        style={{
                            alignSelf: "center",
                        }}
                    >
                        Log Out
                    </BSL_Button>
                </BSL_Common.SectionContainer>

                <div style={{ minHeight: "20px" }}></div>
            </div>
            <Message
                open={showMessage}
                message={showMessage?.message}
                type={showMessage?.type}
                onClose={() => setShowMessage(null)}
            />
        </Drawer>
    );
}
